import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import md5 from 'md5';

import ConfirmDialog from './ConfirmPopup';
import Snackbar from '../../labels/Snackbar';
import LastInstanceMenu from './LastInstances';
import InstanceOpenedMenu from './InstanceOpenedMenu';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/api.form.actions';

import Grid from '@material-ui/core/Grid';
import Unarchive from '@material-ui/icons/Unarchive';
import ViewList from '@material-ui/icons/ViewList';
import CircularProgress from '@material-ui/core/CircularProgress';

import { SaveIcon, ContinueIcon } from '../../../images/icons/WrapSvg';


function flatTree(list) {
    if (list && list.length > 0) {
        return list.reduce((arr, node) => {
            const childs = node.hijos;
            arr.push({
                valor: node.valor,
                codigo: node.codigo,
                comentario: node.comentario,
                fechahoramodificacion: node.fechahoramodificacion,
                metadatos: node.metadatos,
                alertarango: node.alertarango,
                visible: !node.oculto,
                desactivado: node.desactivado
            });
            if (childs && childs.length > 0) {
                arr = arr.concat(flatTree(childs));
            }
            return arr;
        }, []);
    } else {
        return [];
    }
}

class Bar extends React.Component {
    state = {
        error: '',
        errorType: undefined,
        instance: {},
        instance_changes: [],
        instanceOpenedMenu: undefined,
        lastInstanceMenu: undefined
    };

    static getDerivedStateFromProps(props, state) {
        const { instance_changes, instance } = props;
        if (instance !== state.instance || instance_changes !== state.instance_changes) {
            state.instance = instance;
            state.instance_changes = instance_changes;
            return state;
        }
        return null;
    }

    handleSave = (id, changes) => {
        if (this.state.instance_changes.length > 0 && changes.length > 0) {
            this.props
                .saveInstance(id, changes, this.props.local, this.props.empleado)
                .then((r) => {
                    if (r.error) {
                        this.setState({ error: r.error.message, errorType: r.error.type });
                    }
                })
                .catch((error) => this.setState({ error: error.message, errorType: error.type }));
        }
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    handleTransition = (id, changes, ok, code, title) => {
        if (ok && code !== undefined) {
            const message = this.props.intl.formatMessage({ id: 'confirm_transition' }, { 0: title.toUpperCase() });
            this.setState({
                id: id,
                changes: changes,
                code: code,
                confirm: true,
                confirm_title: title,
                confirm_text: message, //Format(message, [title.toUpperCase()]),
            });
        }
    };

    handleConfirm = (value) => {
        if (value) {
            const { id, changes, code } = this.state;
            this.props
                .executeTransition(id, changes, code, this.props.local, this.props.empleado)
                .then((r) => {
                    if (r && r.error) {
                        this.setState({
                            error: r.error.message,
                            errorType: r.error.type,
                            id: undefined,
                            changes: undefined,
                            code: undefined,
                        });
                    } else {
                        this.props.history.push('/processes');
                    }
                })
                .catch((error) => this.setState({ error: error.message, errorType: error.type }));
        }
        this.setState({ confirm: false });
    };

    handleLastInstanceClick = event => {
        if (this.props.last_instance_opened.length > 0) {
            this.setState({ lastInstanceMenu: event.currentTarget });
        }
    };

    onCloseLastInstanceClick = option => {

        if (option) {

            const { instance } = this.state;
            const { id } = this.props;
            const changes = flatTree(instance.tabs);

            if (changes.length > 0) {
                this.props
                    .saveInstance(id, changes, this.props.local, this.props.empleado)
                    .then((r) => {
                        if (r.error) {
                            this.setState({ error: r.error.message });
                        }
                        this.props.history.push('/processes/' + option.code_family + "/" + option.code + "/" + option.id);
                    })
                    .catch((error) => this.setState({ error: error.message }));
            }
            else {
                this.props.history.push('/processes/' + option.code_family + "/" + option.code + "/" + option.id);
            }
        }

        this.setState({ lastInstanceMenu: undefined });
    };

    handleInstanceOpenedClick = event => {
        console.log('handleInstanceOpenedClick');
        if (this.props.instances_opened.length > 0) {
            this.setState({ instanceOpenedMenu: event.currentTarget });
        }
    };

    onCloseInstanceOpenedClick = option => {

        if (option) {

            const { instance } = this.state;
            const { id } = this.props;
            const changes = flatTree(instance.tabs);

            if (changes.length > 0) {
                this.props
                    .saveInstance(id, changes, this.props.local, this.props.empleado)
                    .then((r) => {
                        if (r.error) {
                            this.setState({ error: r.error.message });
                        }
                        this.props.history.push('/processes/' + md5(option.familia) + "/" + option.cproceso + "/" + option.id);
                    })
                    .catch((error) => this.setState({ error: error.message }));
            }
            else {
                this.props.history.push('/processes/' + md5(option.familia) + "/" + option.cproceso + "/" + option.id);
            }
        }

        this.setState({ instanceOpenedMenu: undefined });
    };

    render() {
        const { instance, instance_changes, error, errorType, confirm, lastInstanceMenu, instanceOpenedMenu } = this.state;
        const { id, instance_save_is_saving, instance_in_execution, last_instance_opened, instances_opened } = this.props;
        const { transiciones, instancia } = instance;
        let transition = transiciones && transiciones.length > 0 ? transiciones[0] : undefined;

        return (
            <div className="fixedbar bg_bluish c_white">
                <Grid container>
                    <Grid item xs={3} className="fixedbarcell">
                        <ViewList
                            onClick={this.handleInstanceOpenedClick}
                            className={instances_opened.length > 1 ? 'c_white hand' : 'c_cool_grey'}
                        />
                    </Grid>
                    <Grid item xs={3} className="fixedbarcell">
                        <SaveIcon
                            onClick={() => this.handleSave(id, flatTree(instance.tabs))}
                            className={instance_changes.length > 0 ? 'c_white hand' : 'c_cool_grey'}
                        />
                        {instance_save_is_saving && (
                            <CircularProgress size={40} className={'fabProgress c_pea'} />
                        )}
                    </Grid>
                    <Grid item xs={3} className="fixedbarcell">
                        <ContinueIcon
                            onClick={() =>
                                this.handleTransition(
                                    id,
                                    flatTree(instance.tabs),
                                    instancia.finalizado ||
                                    (!instancia.pendiente && transiciones.length === 1),
                                    transition ? transition.codigo : undefined,
                                    transition ? transition.nombre : undefined,
                                )
                            }
                            className={
                                transition !== undefined
                                    ? instancia.finalizado || !instancia.pendiente
                                        ? 'c_white hand'
                                        : 'c_lipstick'
                                    : 'c_cool_grey'
                            }
                        />
                        {instance_in_execution && (
                            <CircularProgress size={40} className={'fabProgress c_pea'} />
                        )}
                    </Grid>
                    <Grid item xs={3} className="fixedbarcell">
                        <Unarchive
                            onClick={this.handleLastInstanceClick}
                            className={last_instance_opened.length > 1 ? 'c_white hand' : 'c_cool_grey'}
                        />
                    </Grid>
                </Grid>
                {error && (
                    <Snackbar
                        open={true}
                        variant={ errorType ? errorType  :  "error" }
                        text={error}
                        nonavbar={true}
                        onClose={this.handleClose}
                    />
                )}
                {confirm && (
                    <ConfirmDialog
                        {...this.props}
                        title={this.state.confirm_title}
                        message={this.state.confirm_text}
                        onClose={this.handleConfirm}
                    />
                )}
                {lastInstanceMenu &&
                    <LastInstanceMenu {...this.props} anchorEl={lastInstanceMenu} onClose={this.onCloseLastInstanceClick} />
                }
                {instanceOpenedMenu &&
                    <InstanceOpenedMenu {...this.props} anchorEl={instanceOpenedMenu} onClose={this.onCloseInstanceOpenedClick} />
                }
            </div>
        );
    }
}

Bar.propTypes = {
    intl: intlShape.isRequired,
    instance_in_execution: PropTypes.bool.isRequired,
    instance_execution: PropTypes.bool.isRequired,
    instance_changes: PropTypes.array.isRequired,
    instance_save_has_error: PropTypes.object.isRequired,
    instance_save_is_saving: PropTypes.bool.isRequired,
    last_instance_opened: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance_in_execution: state.instance_in_execution,
        instance_execution: state.instance_execution,
        instance_changes: state.instance_changes,
        instance_save_has_error: state.instance_save_has_error,
        instance_save_is_saving: state.instance_save_is_saving,
        last_instance_opened: state.last_instance_opened,
        instances_opened: state.instances_opened
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Bar)));



// WEBPACK FOOTER //
// ./src/components/complex/forms/ActionBar.js